/** Launch settings a table takes from the Activity URL on its first socket. */
const SETTINGS = ["variant", "tempo", "goal", "length"] as const;

/**
 * The table socket's URL: the table and its launch settings, never the session, which travels as a
 * WebSocket subprotocol (review 0019 U8). Pure: the page's location comes in as values.
 */
export function socketUrl({
  protocol,
  host,
  search,
  instanceId,
  guildId,
  base = "/api",
}: {
  protocol: string;
  host: string;
  search: string;
  instanceId: string;
  guildId: string | null;
  base?: string;
}): string {
  const scheme = protocol === "https:" ? "wss" : "ws";
  const params = new URLSearchParams(search);
  const query = new URLSearchParams();
  for (const key of SETTINGS) {
    const value = params.get(key);
    if (value !== null) query.set(key, value);
  }
  if (guildId !== null) query.set("guild", guildId);
  const rest = query.toString();
  return `${scheme}://${host}${base}/instances/${encodeURIComponent(instanceId)}/ws${rest === "" ? "" : `?${rest}`}`;
}
